import request from '@/utils/request'
const apiPath = '/sys/sysExternalSendLog'
const sysExternalSendLogApi = {
  /**
   * 新增【系统地址管理】
   */
  getShouKuanLog(data) {
    return request.post(apiPath + '/getShouKuanLog', data, { isFormData: 1 })
  },
  getTuiKuanLog(data) {
    return request.post(apiPath + '/getTuiKuanLog', data, { isFormData: 1 })
  },
  getChangeCityCompany(data) {
    return request.post(apiPath + '/getChangeCityCompany', data, { isFormData: 1 })
  },
  getYongYouVoucherLog(data) {
    return request.post(apiPath + '/getYongYouVoucherLog', data, { isFormData: 1 })
  }
}
export default sysExternalSendLogApi
